"use client";

import React from "react";
import Action from "./Action";
import { Facebook as FacebookIcon } from "@churchofjesuschrist/eden-icons";
import buildURL from "./build-url";
import useValueOnMount from "./use-value-on-mount";
import { jsx as _jsx } from "react/jsx-runtime";
const useFacebookShareUrl = ({
  shareUrl
} = {}) => buildURL("https://www.facebook.com/sharer/sharer.php", {
  search: {
    u: useValueOnMount(() => shareUrl || window.location.href)
  }
});

/**
 * A button that triggers a share to Facebook, to be used within an `ActionBar`.
 * @param {object} props - The component props
 * @param {string} [props.label] - Hidden text label for the button.
 * @param {string} [props.shareUrl] - The URL to share. Defaults to `window.location.href` once mounted.
 * @returns {React.ReactElement} The Facebook component
 */
const Facebook = ({
  shareUrl,
  label = "Facebook",
  ...props
}) => /*#__PURE__*/_jsx(Action, {
  ...props,
  href: useFacebookShareUrl({
    shareUrl
  }),
  Icon: FacebookIcon,
  label: label
});
Facebook.displayName = "Facebook";
export default Facebook;